import { COMPONENT_NAME_PREFIX } from '../constants';
var elementName = COMPONENT_NAME_PREFIX + "quantity-field";
var attributes = {
    INVALID: 'invalid',
    REQUIRED: 'required',
    DISABLED: 'disabled',
};
var classes = {
    ROOT: 'tyl-quantity-field',
    INVALID: 'tyl-quantity-field--invalid',
    REQUIRED: 'tyl-quantity-field--required',
};
var slots = {
    INCREMENT_BUTTON: 'increment-button',
    DECREMENT_BUTTON: 'decrement-button',
    LABEL: 'label',
    HELPER_TEXT: 'helper-text'
};
var selectors = {
    ROOT: "." + classes.ROOT,
    INCREMENT_BUTTON_SLOT: "slot[name=" + slots.INCREMENT_BUTTON + "]",
    DECREMENT_BUTTON_SLOT: "slot[name=" + slots.DECREMENT_BUTTON + "]",
    INCREMENT_BUTTON: "[slot=" + slots.INCREMENT_BUTTON + "] button, button[slot=" + slots.INCREMENT_BUTTON + "]",
    DECREMENT_BUTTON: "[slot=" + slots.DECREMENT_BUTTON + "] button, button[slot=" + slots.DECREMENT_BUTTON + "]",
    TEXT_FIELD: 'tcw-text-field',
    INPUT: 'input[type=number]',
    LABEL: "[slot=" + slots.LABEL + "]",
    HELPER_TEXT: "[slot=" + slots.HELPER_TEXT + "]",
};
export var QUANTITY_FIELD_CONSTANTS = {
    elementName: elementName,
    classes: classes,
    slots: slots,
    selectors: selectors,
    attributes: attributes
};
